import React, { useEffect } from "react";
import "./main.css";

const Approach = () => {
    useEffect(() => {
        const faders = document.querySelectorAll('.fade-in');
      
        const appearOptions = {
          threshold: 0.1,
          rootMargin: "0px 0px -50px 0px"
        };
      
        const appearOnScroll = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('show');
            observer.unobserve(entry.target);
          });
        }, appearOptions);
      
        faders.forEach((fader, index) => {
          const el = fader as HTMLElement; // ✅ típus assertion
          el.style.transitionDelay = `${index * 0.2}s`;
          appearOnScroll.observe(el);
        });
      
      }, []);
  return (
    <section className="approach-section">
         <h1 className="approach-h1 fade-in">Approaching risk and safety in the complex modern landscape</h1>
      <div className="approach-content">
        {/* Bal oldal: kép */}
        <div className="approach-image ">
          <img src="ora.png" alt="Personal" className="approach-image  fade-in"/>
        </div>

        {/* Jobb oldal: szövegek */}
        <div className="approach-text">
         
          <p className="fade-in">
            Risk has impacted organisations in increasingly complex ways. There is a growing recognition of the threats that humans can pose to individuals,
            organisations and groups, including through a range of behaviour, including bullying, sexual harassment, rule violating behaviour, 
            fixated or grievance-fuelled violence and insider risk.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Approach;
